import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { BulkEditConfigurationComponentProps } from './bulk-edit-configuration.component';

export interface BulkDuplicateConfigurationComponentProps {
    show: boolean;
    onClick: () => void;
}

export const BulkDuplicateConfigurationComponent: React.FC<BulkEditConfigurationComponentProps> = (props) => {
    const { show, onClick } = props;

    const { t } = useTranslation();

    return show ? (
        <PocButton
            className="bulk-action"
            data-testid="bulk-action-duplicate"
            variant="tertiary"
            size="medium"
            onClick={onClick}
        >
            <PocIcon slot="prefix" name="copy" family="outlined" />
            {t('settings.devices.device-settings.device-config-layout.bulk.action.copyFrom')}
        </PocButton>
    ) : undefined;
};
